import React from 'react'

const MyProfile = React.lazy(() => import("../pages/dashboard/my_profile/MyProfile"))
const MyApplication = React.lazy(() => import("../pages/dashboard/my_application/MyApplication"))
const MyApplicationDetails = React.lazy(() => import("../pages/dashboard/my_application_details/MyApplicationDetails"))
const CreateProposal = React.lazy(() => import("../pages/dashboard/my_application_details/create_proposal/CreateProposal"))
const ChangePassword = React.lazy(() => import("../pages/dashboard/change_password/ChangePassword"))
const ChangeEmail = React.lazy(() => import("../pages/dashboard/change_email/ChangeEmail"))

const routes = [
    { path: 'my-profile', name: 'My Profile', element: MyProfile },
    { path: 'my-proposal', name: 'My Proposal', element: MyApplication },
    { path: 'my-proposal/:id', name: 'My Proposal Details', element: MyApplicationDetails },
    { path: 'my-proposal/:id/create', name: 'Create Proposal', element: CreateProposal },
    { path: 'change-password', name: 'Change Password', element: ChangePassword },
    { path: 'change-email', name: 'Change Email', element: ChangeEmail },
]

export default routes
